



import Component from 'vue-class-component'
import DefaultSelect  from '@/components/lib/select/DefaultSelect.vue'
import {SelectModel} from '@/services/types'
import {ISelectStatus} from './ISelectStatus'

@Component({
    components: {
        DefaultSelect
    }
})
export default class SelectStatus extends ISelectStatus {
    private componentClass = 'SelectStatus'

    private  statusSelectOptions: SelectModel [] = [
        {
            value: 'ACTIVE',
            text: 'Активна'
        },
        {
            value: 'INACTIVE',
            text: 'Деактивирована'
        }
    ]
}
